import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";

import { db } from "../firebase";
import { UserData } from "../types/UserData";
import { useLoading } from "./useLoading";

// ログイン中の自分自身のユーザー情報は useCurrentUser（CurrentUserProvider）が
// アプリ全体で1回だけ取得して共有しているため、ここでは重複して取得しない。
// currentUserが必要な場合は useCurrentUser を使うこと。
export const useUsers = () => {
  const [users, setUsers] = useState<UserData[]>([]);

  const { isLoading, setIsLoading } = useLoading();

  const fetchUsers = async () => {
    try {
      setIsLoading(true);

      const snapshot = await getDocs(collection(db, "users"));

      const list: UserData[] = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...(doc.data() as Omit<UserData, "id">),
      }));

      setUsers(list);
    } catch (error) {
      console.error("users取得エラー:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return {
    loading: isLoading,
    users,
    fetchUsers,
  };
};
